import { useTranslation } from 'react-i18next';
import { Grid, Paper, Stack, Typography } from '@mui/material';
import { RangePlanningItem } from '../types';

interface PricingTabProps {
  item: RangePlanningItem;
}

const PricingTab = ({ item }: PricingTabProps) => {
  const { t } = useTranslation('rangePlanningItems');
  const { pricing } = item;
  const priceChange = pricing.previousPrice
    ? ((pricing.contractPrice - pricing.previousPrice) / pricing.previousPrice) * 100
    : 0;

  return (
    <Paper variant="outlined"
      sx={{ p: 4 }}>
      <Grid container
        spacing={5}>
        <Grid item
          md={3}
          sm={6}
          xs={12}>
          <Stack spacing={0.5}>
            <Typography variant="textXS"
              color="text.secondary">{t('contractPrice', 'Contract Price')}</Typography>
            <Typography variant="textMD"
              fontWeight={600}>{pricing.currency} {pricing.contractPrice.toFixed(2)}</Typography>
          </Stack>
        </Grid>
        {pricing.spotPrice != null && (
          <Grid item
            md={3}
            sm={6}
            xs={12}>
            <Stack spacing={0.5}>
              <Typography variant="textXS"
                color="text.secondary">{t('spotPrice', 'Spot Price')}</Typography>
              <Typography variant="textMD"
                fontWeight={600}
                color={pricing.spotPrice > pricing.contractPrice ? 'error.main' : 'text.primary'}>
                {pricing.currency} {pricing.spotPrice.toFixed(2)}
              </Typography>
            </Stack>
          </Grid>
        )}
        {pricing.previousPrice != null && (
          <Grid item
            md={3}
            sm={6}
            xs={12}>
            <Stack spacing={0.5}>
              <Typography variant="textXS"
                color="text.secondary">{t('priceChange', 'Change since previous')}</Typography>
              <Typography variant="textMD"
                fontWeight={600}
                color={priceChange > 0 ? 'error.main' : priceChange < 0 ? 'success.main' : 'text.primary'}>
                {priceChange > 0 ? '+' : ''}{priceChange.toFixed(1)}%
              </Typography>
            </Stack>
          </Grid>
        )}
        <Grid item
          md={3}
          sm={6}
          xs={12}>
          <Stack spacing={0.5}>
            <Typography variant="textXS"
              color="text.secondary">{t('priceEffectiveDate', 'Effective from')}</Typography>
            <Typography variant="textMD"
              fontWeight={600}>{pricing.priceEffectiveDate}</Typography>
          </Stack>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default PricingTab;
